export const NULL_CAMPAIGN = '_NULL'

export const APP_WEBVIEW_CAMPAIGN = '006'

export const PKCONTILIM_CAMPAIGN = 'PKCONTILIM'

export const MTS_CAMPAIGN = 'MTS'

export const DIRECT_PACKAGE_CAMPAIGNS = ['2HRSFACE', '2HRSINSTA', '2HRSX', '2HRSY']

export const PACKAGES_CAMPAIGNS = [
  '010',
  '011',
  '012',
  '013',
  'IMOX',
  'MDPLUS',
  'MIMEDIA',
  'FACE',
  'INSTA',
  'XES',
  'CAPP',
  'CAPPSL',
  'CAPPINT',
  'CAPPREC',
  'MDR1',
  'MDR2'
]

export const SEND_BALANCE_CAMPAIGN = 'REC03'

export const REQUEST_BALANCE_CAMPAIGN = 'SOLICITARSALDO'

export const BOTONSALDO_CAMPAIGN = 'BOTONSALDO'

export const CSALDO_CAMPAIGN = 'CSALDO'

export const CSLD_CAMPAIGN = 'CSLD'

export const MIXTO_CAMPAIGN = 'MIXTO'

export const ORQUESTADOR_MIX_CAMPAIGN = 'ORQUESTADOR_MIX'

export const CAMPAIGN_015 = '015'

export const PK_CAMPAIGN_PREFIX = 'PK'

export const PQ_CAMPAIGN_PREFIX = 'PQ'

export const CR_CAMPAIGN_PREFIX = 'CR'

export const PACKAGE_CAMPAIGN_PREFIXES = [
  PK_CAMPAIGN_PREFIX,
  PQ_CAMPAIGN_PREFIX,
  CR_CAMPAIGN_PREFIX
]

export const TELCEL_ADS_CAMPAIGNS = [MIXTO_CAMPAIGN, ORQUESTADOR_MIX_CAMPAIGN, CAMPAIGN_015]

export const BALANCE_CAMPAIGNS = [BOTONSALDO_CAMPAIGN, CSALDO_CAMPAIGN, CSLD_CAMPAIGN]
